import React from 'react';
import { pctSymbol } from '../../utils/formatters';

const SuccessionPlanningProgressBar = ({ 
  currentSection = 0, 
  totalSections = 1, 
  completionPercentage = 0,
  showPercentage = true,
  showSectionCounter = true,
  size = 'default' // 'small', 'default', 'large'
}) => {
  const percentage = completionPercentage || Math.round((currentSection / totalSections) * 100);
  
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return {
          container: 'space-y-1',
          bar: 'h-1',
          text: 'text-xs'
        };
      case 'large':
        return {
          container: 'space-y-3',
          bar: 'h-3',
          text: 'text-base'
        };
      default:
        return {
          container: 'space-y-2',
          bar: 'h-2',
          text: 'text-sm'
        };
    }
  };

  const sizeClasses = getSizeClasses();

  return (
    <div className={`w-full ${sizeClasses.container}`}>
      {/* Progress Header */}
      <div className="flex justify-between items-center">
        {showSectionCounter && (
          <span className={`font-medium text-succession-text-primary transition-colors duration-300 ${sizeClasses.text}`}>
            Section {currentSection + 1} of {totalSections}
          </span>
        )}
        {showPercentage && (
          <span className={`font-medium text-succession-text-primary transition-colors duration-300 ${sizeClasses.text}`}>
            {percentage}{pctSymbol()}
          </span>
        )}
      </div>
      
      {/* Progress Bar */}
      <div className={`w-full bg-succession-bg-tertiary rounded-full transition-colors duration-300 ${sizeClasses.bar}`}>
        <div 
          className={`bg-succession-primary rounded-full transition-all duration-500 ease-out ${sizeClasses.bar}`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      
      {/* Progress Description */}
      {size === 'large' && (
        <p className="text-succession-text-secondary transition-colors duration-300 text-sm">
          {percentage < 25 
            ? 'Just getting started...' 
            : percentage < 50 
            ? 'Making good progress!' 
            : percentage < 75 
            ? 'You\'re more than halfway there!' 
            : percentage < 100 
            ? 'Almost finished!' 
            : 'Congratulations! You\'ve completed your succession plan!'}
        </p>
      )}
    </div>
  );
};

export default SuccessionPlanningProgressBar; 